import request from "@/utils/request";

export const productList = {
  list: (params) =>
    request({
      url: "/api/backend/integral/commodity/list",
      method: "GET",
      params,
    }),
  merchantList: (params) =>
    request({
      url: "/api/backend/evaluation/store/list",
      method: "GET",
      params,
    }),
  create: (data) =>
    request({
      url: "/api/backend/integral/commodity/add",
      method: "POST",
      data,
    }),
  changeState: (id) =>
    request({
      url: "/api/backend/integral/commodity/state",
      method: "POST",
      data: { id },
    }),
  delete: (id) =>
    request({
      url: "/api/backend/integral/commodity/del",
      method: "POST",
      data: { id },
    }),
};

export const orderList = {
  list: (params) =>
    request({
      url: "/api/backend/integral/commodity/order/list",
      method: "GET",
      params,
    }),
  shipping: (data) =>
    request({
      url: "/api/backend/integral/commodity/order/delivery",
      method: "POST",
      data,
    }),
  signature: (order_id) =>
    request({
      url: "/api/backend/integral/commodity/order/close",
      method: "POST",
      data: { order_id },
    }),
  exportCreditShopExcel: (params) =>
    request({
      url: "/api/backend/excel/commodity",
      method: "GET",
      params,
    }),
};

export const classify = {
  list: (params) =>
    request({
      url: "/api/backend/integral/commodity/class/list",
      method: "GET",
      params,
    }),
};
